export const ENCRYPTION_KEY = "b555929f-da81-4ec0-b88c-cda7b8843901"
export const DEVICE_NAME = "web"